import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";

import { getMentorForms } from "./dependencies/action";

import LinearStepperCohort from "./LinearStepperCohort";
// import CohortStartupForm from "./CohortStartup/CohortStartupForm";

import { CssBaseline, Container, Paper, Box } from "@material-ui/core";
import applyIcon from "../../assets/images/close_icon.svg";

import { initGA, logPageView } from "../../analytics";
import { PRODUCTION_MOVE_HIDDEN } from "../common/constants/actionConstants";

const CohortForm = (props) => {
  const history = useHistory();
  const LoginRole = localStorage.getItem("SavedLoggedInData")
    ? JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role
    : history.push("/");

  useEffect(() => {
    // to call the initialise google analytics funtion
    try {
      initGA();
      window.GA_INITIALIZED = true;
      // to save the number og visitors on this side
      logPageView();
    } catch (error) {}
  }, [window]);

  const { getMentorForms, mentorFormList } = props;
  useEffect(() => {
    // getMentorForms();
  }, [getMentorForms]);

  useEffect(() => {
    if (PRODUCTION_MOVE_HIDDEN) {
      history.push("/");
    }
    localStorage.removeItem("showPending");
    localStorage.removeItem("mentorDashboardHome");
    // localStorage.removeItem("startUpApplications");
    // localStorage.removeItem("mentorStartupRequest");
    // localStorage.removeItem("cohortProgram");
    // localStorage.removeItem("cohortApplication");
    localStorage.removeItem("toMentorAction");
    // localStorage.removeItem("cohortStartup");
    // localStorage.removeItem("cohortMentors");
    localStorage.removeItem("mentorRequests");
    localStorage.removeItem("activitySummary");
    localStorage.removeItem("activitySummary2");
    localStorage.removeItem("activitySummary3");
    localStorage.removeItem("activitySummary4");
    localStorage.removeItem("activitySummary5");
    localStorage.removeItem("activityCohortTotal");
    localStorage.removeItem("activityCohortDetails");
    localStorage.removeItem("mentorshipClosed");
    localStorage.removeItem("mentorshipScheduled");
    localStorage.removeItem("mentorMentorships");
    localStorage.removeItem("mentorshipTotal");
    localStorage.removeItem("mentorshipSession");
    localStorage.removeItem("startupMentorshipHours");
    localStorage.removeItem("startupRequestAccepted");
    localStorage.removeItem("startupRequestSent");
    localStorage.removeItem("MyCohortStartupDashboard");
    localStorage.removeItem("MyCohortMentorDashboard")
  }, []);

  return (
    <div
      // style={{ paddingTop: "70px" }}
      // style={{
      //   marginTop: "5rem",
      //   // paddingTop: "25px",
      //   // backgroundColor:"#000",
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundImage:
      //     "linear-gradient(119deg, #D2D8ED 0%, #EFF9FD 53%, #ffffff 100%)",
      //   // backgroundImage: `url(${formbg})`,
      // }}
      className="mainformdivcohort cohortFormPage"
    >
      <div
        className=""
        style={{
          marginRight: "85px",
          marginTop: "10px",
          height: "40px",
          visibility:
            JSON.parse(localStorage.getItem("SavedLoggedInData"))
              .applicationStatus === "PENDING" && "hidden",
        }}
      >
        <div className="newUserTooltip">
          <div
            className="right-close"
            onClick={() => {
              if(history.location.state?.fromPage == "cohortForm"){
                localStorage.setItem("cohortNewDashboard", "cohortNewDashboard");
                history.push({
                  pathname: "/dashboard",
                  state: "cohortNewDashboard",
                });
              }
              if (history?.location?.state?.fromPage === "cohort-new-dasboard") {
                // props.setSelectedMenu("MyCohortMentorDashboard");
                localStorage.setItem("cohortNewDashboard", "cohortNewDashboard");
                history.push({
                  pathname: "/dashboard",
                  state: "cohortNewDashboard",
                });
              } 
            else  if (history?.location?.state?.fromPage === "cohort-program") {
                history.push({
                  pathname: "/cohort-program",
                  state: "cohortForm",
                });
              } else if (
                history?.location?.state?.fromPage === "cohort-application"
              ) {
                // window.location.reload();
                history.push({
                  pathname: "/dashboard",
                  state: "cohortForm",
                });
              } else if (history?.location?.state?.fromPage === "cohort-sidebar") {
                window.location.reload();
                // history.push({
                //   pathname: "/dashboard",
                //   state: "cohortForm",
                // });
              }
              else if (history?.location?.state?.fromPage === "aboutPage") {
                history.push( `/cohort-programs/cohortView/${history?.location?.state?.data?.cohortId}`)
              }
               else {
                localStorage.setItem(
                  "MyCohortMentorDashboard",
                  "MyCohortMentorDashboard"
                );
                // window.location.reload();
                history.push({
                  pathname: `/dashboard`,
                  state: "cohortForm",
                });
                // window.location.reload();
                // history.push({
                //   pathname: "/dashboard",
                //   state: "cohortForm",
                // });
              }
            }}
            //        onClick={ ()=>{
            //         if(history?.location?.state?.fromModule !== undefined && history?.location?.state?.fromModule !== null && history?.location?.state?.fromModule !== "" && history?.location?.state?.fromModule === "cohortProgram")
            //         history.push({
            //         pathname: "/dashboard",
            // state:'cohortProgram'
            //        })}}
            //  onClick={()=>history.goBack()}
            // onClick={() => {
            //
            //    if(LoginRole === "Mentor"){
            //     if(history?.location?.state?.fromModule !== undefined && history?.location?.state?.fromModule !== null && history?.location?.state?.fromModule === "cohortStartupRequest")
            //     {
            //       props.setSelectedMenu("cohortStartup");
            //     history.push("/dashboard");
            //     }
            //     else if(history?.location?.state?.fromModule !== undefined && history?.location?.state?.fromModule !== null && history?.location?.state?.fromModule === "cohortMentorApplication")
            //     {
            //       props.setSelectedMenu("cohortApplicationMentor");
            //     history.push("/dashboard");
            //     }
            //     else if(history?.location?.state?.fromModule !== undefined && history?.location?.state?.fromModule !== null && history?.location?.state?.fromModule === "cohortMentorRequest")
            //     {
            //       props.setSelectedMenu("cohortMentors");
            //     history.push("/dashboard");
            //     }
            //     else{
            //     props.setSelectedMenu("adminMenu");
            //     history.push("/dashboard");
            //     }
            //    }
            //    else{
            //     props.setSelectedMenu("cohortApplication");
            //     history.push("/dashboard");
            //    }
            //     // localStorage.setItem(
            //     //   "mentorDashboardHome",
            //     //   "mentorDashboardHome"
            //     // );

            //     // window.location.reload();
            //   }}
          >
            <img src={applyIcon} />{" "}
            <span className="tooltiptext tooltip-bottom">Close</span>
          </div>
        </div>
      </div>
    
      <h2>
        <p
          className="formHeadingCohortFormPurple homepageFirstHeader"
          style={{ paddingTop: "15px" }}
        >
         
          {
            history.location.state?.data?.applicationStatus == "VERIFIED" ?
            "Cohort Program":
            (history.location.state?.fromPage == "cohortForm" ||  history.location.state?.applicationStatus == "VERIFIED" || history.location.state?.data?.applicationStatus == "DRAFT" || history.location.state?.data?.applicationStatus == "REQUESTINFO") &&
            "Creat a Cohort"
          }{" "}
        </p>
      </h2>
      <CssBaseline />
      <Container component={Box}>
        <Paper component={Box}>
          <div style={{ paddingBottom: "25px" }}>
            <LinearStepperCohort />
          </div>
          {/* <CohortStartupForm/> */}
        </Paper>
      </Container>
      <div className="formgraphicdiv"></div>
    </div>
  );
};

const mapStateToProps = (state) => {
  //
  //
  return {
    // mentorFormList: state.GetMentorFormReducer.getMentorFormList,
  };
};
export default connect(mapStateToProps)(withRouter(CohortForm));

// export default MentorForm;
